module.exports = __webpack_public_path__ + "static/media/uploadImg.cf1ceab2.svg";